import React from "react";
import ServiceCard from "./ServiceCard";

const ServicesSec = () => {
  const services = [
    {
      img: "/srv1.png",
      title: "Distribution",
      list: [
        "Satellite Distribution",
        "OTT & Distribution Network",
        "OTT & Streaming Distribution",
        "Broadcast Distribution",
        "Remote Production",
      ],
      link: "/services/distribution",
    },
    {
      img: "/srv2.png",
      title: "Playout",
      list: [
        "Channel Playout (SD/HD/UHD/4K)",
        "Disaster Recovery Playout",
        "Multi-Platform Delivery",
        "Channel Compliance & Monitoring",
        "End-to-End Playout Services",
      ],
      link: "/services/playout",
    },
    {
      img: "/srv3.png",
      title: "Creative",
      list: [
        "Digital and Live Highlights Creation",
        "On-air Graphics & Branding",
        "Content Localization & Versioning",
        "Promo & On-air Packaging",
        "Studio Support",
      ],
      link: "/services/creative",
    },
    {
      img: "/srv4.png",
      title: "Cloud",
      list: [
        "Cloud Content Services",
        "Hybrid Cloud Playout",
        "Cloud-based Media Processing",
        "Global Media Asset Hosting",
        "Cloud Storage & Archiving",
      ],
      link: "/services/cloud",
    },
    {
      img: "/srv5.png",
      title: "Satellite & IoT",
      list: [
        "VSAT/Uplink/IoT/M2M Connectivity",
        "Satellite Broadcast & Connectivity Management",
        "IoT Device and Connectivity Management",
        "IoT Asset Tracking & Remote Monitoring",
        "IoT Data Tracking & Remote Monitoring",
      ],
      link: "/services/satellite-iot",
    },
    {
      img: "/srv6.png",
      title: "Network",
      list: [
        "Managed L2/L3 Services",
        "IP Transit & MPLS",
        "Fiber & Wireless Network Services",
        "Network Security & Monitoring",
        "Network Planning & Reporting",
      ],
      link: "/services/network",
    },
    {
      img: "/srv7.png",
      title: "Asset Mgmt",
      list: [
        "Media Storage Services",
        "Digital Rights & Conditional Access",
        "Physical & Digital Asset Management",
        "Tape & Disk Archiving",
        "Digital Rights Management (DRM)",
      ],
      link: "/services/asst-mgmt",
    },
    {
      img: "/srv8.png",
      title: "Teleport",
      list: [
        "Uplink & Downlink Services",
        "Earth Station Operations",
        "24/7 NOC & MCR Support",
        "Carrier Monitoring",
        "Antenna Hosting",
      ],
      link: "/services/teleport",
    },
  ];
  return (
    <section className="services-sec">
      <img src="/srv-bg.png" alt="heading-img" className="heading-img" />
      <img src="/map.png" alt="map-img" className="map-img" />
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-12">
            <div className="heading-wrapper">
              <h2 className="sec-head white">Our Services</h2>
              <p className="para white">
                Our services span the full media and connectivity ecosystem —
                from global content distribution to cloud, satellite, IoT, and
                network solutions. We deliver secure, scalable, and future-ready
                infrastructure tailored to your needs.
              </p>
            </div>
          </div>
        </div>
        <div className="row row-gap-25 mt-4">
          {services.map((service, index) => (
            <div className="col-lg-3 col-12" key={index}>
              <ServiceCard data={service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSec;
